import { IAppointment } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { BaseStateExtension } from '@common/state/state-extension';
import { AppointmentModelName } from 'src/app/shared/models/model-names';

export const SERVICES_APPOINTMENTS_TAB_APPOINTMENT_STATE_NAME = 'ServiceTabAppointmentStateName';

@Injectable({ providedIn: 'root' })
export class ServiceTabAppointmentStateExtension extends BaseStateExtension<IAppointment> {
  public name = AppointmentModelName;
  public patientIdToObserve: string | null = null;

  public async canBeStored(item: IAppointment): Promise<boolean> {
    if (!this.patientIdToObserve || !item || item.archived || !item.patientIds?.length) {
      return false;
    }
    return item.patientIds.includes(this.patientIdToObserve);
  }

  protected afterCreateInternal(item: IAppointment): void {
    this.stateRegistry.createBySync(AppointmentModelName, SERVICES_APPOINTMENTS_TAB_APPOINTMENT_STATE_NAME, item);
  }

  protected afterUpdateInternal(item: IAppointment): void {
    this.stateRegistry.updateBySync(AppointmentModelName, SERVICES_APPOINTMENTS_TAB_APPOINTMENT_STATE_NAME, [item]);
  }

  protected removeFromState(item: IAppointment): void {
    this.stateRegistry.removeBySync(AppointmentModelName, SERVICES_APPOINTMENTS_TAB_APPOINTMENT_STATE_NAME, [item]);
  }
}
